import { Component, Input, OnInit } from '@angular/core';
import { TalonOneItem, TalonOneWebCode } from 'src/app/shared-core/models/cart-data.model';
import { CartService } from 'src/app/shared-core/services/cart.service';

@Component({
  selector: 'app-promotion-item',
  templateUrl: './promotion-item.component.html',
  styleUrls: ['./promotion-item.component.scss']
})
export class PromotionItemComponent implements OnInit {

  TalonOneWebCode = TalonOneWebCode;
  @Input() item: TalonOneItem;
  constructor(private service: CartService) { 

  }

  ngOnInit(): void {
  }

  removeItem(){
    this.service.updatePromoCode('').subscribe(

    );
  }

}
